module.exports = "https://www.gc-pro.gnp.com.mx/4dfabc851583160f975ed96e96f299de.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/warning-icono.png
// module id = 8178
// module chunks = 0